export enum CardType {
    American = "American",
    Asian = "Asian",
    Multiview = "Multiview",
    Regular = "Regular"
}